<template>
	<div class="mt-4">
		<div
			v-if="$slots.default"
			class="mb-2 text-sm font-semibold text-gray-800"
		>
			<slot />
		</div>

		<input 
			v-model="skill"
			:placeholder="props.placeholder"
			type="text"
			:class="[
				inputStyle,
			]"
			@keyup.enter="handleAddSkill"
			@blur="emit('input:blur')"
		/>

		<div
			v-if="$slots?.subtitle"
			class="mt-0.5"
		>
			<slot name="subtitle" />
		</div>

		<div class="flex flex-row flex-wrap justify-start gap-x-2">
			<div
				v-for="skill in skills"
				:key="skill"
				classs="
					flex justify-between items-center mt-1 flex-nowrap bg-[#F2FAFF]
					rounded-lg block px-1.5 py-px
				"
			>
				<span class="inline-block font-[Inter] text-xs font-normal text-won-blue italic">{{ skill }}</span>
                
				<span
					class="inline-block cursor-pointer pl-1"
					@click="() => handleDelete(skill)"
				>
					<img
						class="h-3"
						:src="CloseImage"
					/>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { inputStyle } from '../../utils/styles';

const CloseImage = '/img/close.png';

const props = defineProps({
	placeholder: {
		type: String,
		default: null
	},
	modelValue: {
		type: Array,
		default() {
			return [];
		}
	},
});

const skill = ref(null);
const skills = ref([]);

const emit = defineEmits(['update:modelValue', 'input:blur']);

const handleAddSkill = () => {
	if (! skill.value) {return;}
	if (skills.value.find((el) => el === skill.value)) {return;}

	skills.value.push(skill.value);
	skill.value = '';

	handleChange(skills.value);
};

const handleDelete = (skill) => {
	skills.value = skills.value.filter((el) => el !== skill);
	handleChange(skills.value);
};

const handleChange = (val) => {
	emit('update:modelValue', val);
};
</script>
